/**
 * This atob polyfill was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function atobPolyfill(input: string): string {
  const str = String(input).replace(/=+$/, '');
  if (str.length % 4 === 1) {
    throw new Error("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    (buffer = str.charAt(idx++));
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer &&
    // @ts-ignore
    ((bs = bc % 4 ? bs * 64 + buffer : buffer),
    // and if not first of each 4 characters,
    // convert the first 8 bits to one ascii character
    bc++ % 4)
      ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
      : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}

function b64DecodeUnicode(str: string): string {
  const encoded: string = atob(str).replace(/(.)/g, (_, p: string) => {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  });
  return decodeURIComponent(encoded);
}

function base64UrlDecode(str: string): string {
  let output = str.replace(/-/g, '+').replace(/_/g, '/');
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += '==';
      break;
    case 3:
      output += '=';
      break;
    default:
      throw Error('Illegal base64url string!');
  }

  try {
    return b64DecodeUnicode(output);
  } catch (err) {
    return (window.atob || atobPolyfill)(output);
  }
}

interface JwtDecoded {
  aud?: string | string[];
  exp?: number;
  iat?: number;
  iss?: string;
  jti?: string;
  nbf?: number;
  sub?: string;
}

/**
 * Decode a Base64Url encoded JWT token.
 *
 * @throws Error when `token` is an invalid JWT token.
 *
 * @example
 * // Supply the fields of interest as the generic type:
 * const result = decodeJwt<{ roles: string[] }>(token);
 */
export function decodeJwt<T extends Record<string, unknown>>(token: string): JwtDecoded & T {
  try {
    return JSON.parse(base64UrlDecode(token.split('.')[1]));
  } catch (error) {
    if (error instanceof Error) {
      throw Error('Invalid token: ' + error.message);
    }
    throw Error('Invalid token.');
  }
}
